import { render } from "./LKFHeader.vue?vue&type=template&id=5475e408&ts=true"
import script from "./LKFHeader.vue?vue&type=script&lang=ts"
export * from "./LKFHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__